import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { toBusinessDate } from '../format/jalali';

function parseBusinessDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) {
    return null;
  }
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(date.getTime()) ? null : date;
}

/** تاریخ کسب‌وکاری yyyy-MM-dd با DatePicker شمسی. مقدار خالی یعنی تهی. */
export function BusinessDateField({
  label,
  value,
  onChange,
  testId,
}: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  testId?: string;
}) {
  return (
    <DatePicker
      label={label}
      value={parseBusinessDate(value)}
      onChange={(date) => onChange(date && !Number.isNaN(date.getTime()) ? toBusinessDate(date) : '')}
      slotProps={{ textField: { sx: { width: 220 }, inputProps: { 'data-testid': testId } } }}
    />
  );
}
